import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { Checkbox } from "../components/ui/checkbox";

const PHASES = [
  { key: "intake", title: "Intake Process", desc: "From first call to signed engagement." },
  { key: "offer", title: "Offer Strategy", desc: "Comps, escalation, terms that win in Atlanta." },
  { key: "closing", title: "30-Day Closing Timeline", desc: "From contract to keys." },
  { key: "protection", title: "Client Protection Checklist", desc: "Insurance, warranty, surveys." },
];

export default function Buyer() {
  const [items, setItems] = useState([]);
  const [done, setDone] = useState({});
  useEffect(() => { api.get("/content/buyer_steps").then(r => setItems(r.data || [])); }, []);

  const byPhase = useMemo(() => {
    const map = {};
    for (const p of PHASES) map[p.key] = [];
    for (const it of items) if (map[it.phase]) map[it.phase].push(it);
    for (const k of Object.keys(map)) map[k].sort((a, b) => a.order - b.order);
    return map;
  }, [items]);

  return (
    <div className="space-y-8" data-testid="buyer-page">
      <header>
        <div className="overline">Agent Playbook</div>
        <h1 className="font-heading text-5xl mt-2">Buyer System</h1>
        <p className="text-sm text-[#050303]/60 mt-2">Intake → offer → closing → protection.</p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {PHASES.map(p => (
          <div key={p.key} className="core-card p-7" data-testid={`phase-${p.key}`}>
            <div className="overline">{p.desc}</div>
            <h3 className="font-heading text-2xl mt-1 mb-4">{p.title}</h3>
            <ol className="space-y-3">
              {byPhase[p.key].map((i, idx) => (
                <li key={i.id} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-[#e1b7c1]/40 text-[#bf858e] text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">{idx + 1}</span>
                  <Checkbox checked={!!done[i.id]} onCheckedChange={(v) => setDone(d => ({ ...d, [i.id]: !!v }))}
                    data-testid={`buyer-check-${i.id}`}
                    className="mt-1 data-[state=checked]:bg-[#050303] data-[state=checked]:border-[#050303]" />
                  <span className={`text-sm ${done[i.id] ? "line-through text-[#050303]/40" : ""}`}>{i.title}</span>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </div>
  );
}
